module.exports = __webpack_public_path__ + "e9f1c93b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gogox-logo.svg
// module id = 1015
// module chunks = 4 5